<template>
  <div class="appointment-item">
    <div class="order-card">
      <!-- 头部区域 -->
      <div class="order-header">
        <div class="order-number">
          预约编号: {{assignmentItem.appointmentNo}}
        </div>
        <div class="order-status">
          <van-tag mark :type="assignmentItem.bpmStatusType" size="medium" plain>{{assignmentItem.bpmStatusTitle}}</van-tag>
        </div>
      </div>
      
      <!-- 信息区域 -->
      <div class="order-info">
        <div class="info-item">
          <span class="info-label"><van-icon name="manager-o" /> 司机姓名:</span>
          <span class="info-value">{{assignmentItem.driverName}}</span>
        </div>
        <div class="info-item">
          <span class="info-label"><van-icon name="guide-o" /> 车头号:</span>
          <span class="info-value">{{assignmentItem.headstock}}</span>
        </div>
        <div class="info-item">
          <span class="info-label"><van-icon name="cluster-o" /> 车挂号:</span>
          <span class="info-value">{{assignmentItem.handnum}}</span>
        </div>
        <div class="info-item">
          <span class="info-label"><van-icon name="goods-collect-o" /> 上一载重品种:</span>
          <span class="info-value">{{assignmentItem.variety}}</span>
        </div>
        <div class="info-item" v-if="assignmentItem.tankMaterial">
          <span class="info-label"><van-icon name="shield-o" /> 罐体材质:</span>
          <span class="info-value">{{assignmentItem.tankMaterial}}</span>
        </div>
        <div class="info-item">
          <span class="info-label"><van-icon name="calendar-o" /> 预约日期:</span>
          <span class="info-value">{{assignmentItem.appointmentTime}}</span>
        </div>
        <div class="info-item">
          <span class="info-label"><van-icon name="clock-o" /> 预约时间:</span>
          <span class="info-value">{{assignmentItem.appointmentPdxx}}</span>
        </div>
        <!-- <div class="info-item">
          <span class="info-label"><van-icon name="location-o" /> 蒸洗口:</span>
          <span class="info-value">{{assignmentItem.steamPort}}</span>
        </div> -->
        <div class="info-item" v-if="assignmentItem.payMethod == '1'">
          <span class="info-label"><van-icon name="balance-o" /> 支付方式:</span>
          <span class="info-value">对公账户支付</span>
        </div>
        <div class="info-item" v-if="assignmentItem.payMethod == '2'">
          <span class="info-label"><van-icon name="paid" /> 支付方式:</span>
          <span class="info-value">个人支付</span>
        </div>
      </div>
      
      <!-- 底部按钮区域 -->
      <div class="order-actions">
        <van-button 
          type="info" 
          size="small" 
          class="action-btn" 
          @click="jumpAssignmentDetail(assignmentItem.id)"
        >
          作业详情
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    assignmentItem:{
      type:Object,
      required: true
    }
  },
  
  methods:{
    jumpAssignmentDetail(id)
    {
      this.$router.push({
        name: 'steamAssignmentInfo',
        params:{
          id:id
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.appointment-item {
  margin-bottom: 12px;
}

.order-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  
  .order-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #f5f6f7;
    
    .order-number {
      font-size: 14px;
      font-weight: 500;
      color: #323233;
    }
  }
  
  .order-info {
    padding: 12px 16px;
    
    .info-item {
      display: flex;
      margin-bottom: 8px;
      align-items: flex-start;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .info-label {
        width: 110px;
        font-size: 14px;
        color: #969799;
        display: flex;
        align-items: center;
        
        .van-icon {
          margin-right: 4px;
          font-size: 16px;
          color: #4080ff;
        }
      }
      
      .info-value {
        flex: 1;
        font-size: 14px;
        font-weight: 500;
        color: #323233;
      }
    }
  }
  
  .order-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    padding: 12px 16px;
    border-top: 1px solid #f5f6f7;
    
    .action-btn {
      margin-left: 8px;
      margin-bottom: 8px;
      border-radius: 4px;
      background-color: #4080ff;
      border: none;
    }
  }
}
</style>
